export default __webpack_public_path__ + "static/stake-6876ecd826bac397715f78dc691497fa.png";